import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function SessionCleanup() {
  const location = useLocation();

  useEffect(() => {
    const handleCancellation = async (sessionId) => {
      try {
        const cancelResponse = await fetch(`${process.env.REACT_APP_API_URL}/handle-cancellation`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ sessionId }),
        });

        if (!cancelResponse.ok) {
          throw new Error(`HTTP error! status: ${cancelResponse.status}`);
        }
      } catch (error) {
        console.error('❌ Cancellation failed:', error.message);
      }
    };

    // Get session ID from URL parameters
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');

    // Only attempt cancellation if we have a session ID and we're on the home page
    if (sessionId && location.pathname === '/') {
      handleCancellation(sessionId);
    }
  }, [location]);

  return null;
}

export default SessionCleanup; 